'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Select = exports.RadioGroup = exports.Toggles = exports.CheckboxGroup = exports.Checkbox = exports.TextArea = exports.Input = undefined;

var _reduxInputs = require('redux-inputs');

Object.keys(_reduxInputs).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _reduxInputs[key];
        }
    });
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _InputField = require('@zillow/react-zsg/InputField');

var _InputField2 = _interopRequireDefault(_InputField);

var _TextAreaField = require('@zillow/react-zsg/TextAreaField');

var _TextAreaField2 = _interopRequireDefault(_TextAreaField);

var _CheckboxField = require('@zillow/react-zsg/CheckboxField');

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _CheckboxGroupField = require('@zillow/react-zsg/CheckboxGroupField');

var _CheckboxGroupField2 = _interopRequireDefault(_CheckboxGroupField);

var _TogglesField = require('@zillow/react-zsg/TogglesField');

var _TogglesField2 = _interopRequireDefault(_TogglesField);

var _RadioGroupField = require('@zillow/react-zsg/RadioGroupField');

var _RadioGroupField2 = _interopRequireDefault(_RadioGroupField);

var _LogicalSelectField = require('@zillow/react-zsg/LogicalSelectField');

var _LogicalSelectField2 = _interopRequireDefault(_LogicalSelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Commonly used input components

// eslint-disable-next-line no-unused-vars
var Input = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref) {
    var validating = _ref.validating,
        pristine = _ref.pristine,
        props = _objectWithoutProperties(_ref, ['validating', 'pristine']);

    return _react2.default.createElement(_InputField2.default, props);
}, {
    onChangeTransform: function onChangeTransform(e) {
        return e.target.value;
    }
});

// eslint-disable-next-line no-unused-vars
exports.Input = Input;
var TextArea = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref2) {
    var validating = _ref2.validating,
        pristine = _ref2.pristine,
        props = _objectWithoutProperties(_ref2, ['validating', 'pristine']);

    return _react2.default.createElement(_TextAreaField2.default, props);
}, {
    onChangeTransform: function onChangeTransform(e) {
        return e.target.value;
    }
});

// eslint-disable-next-line no-unused-vars
exports.TextArea = TextArea;
var Checkbox = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref3) {
    var validating = _ref3.validating,
        pristine = _ref3.pristine,
        props = _objectWithoutProperties(_ref3, ['validating', 'pristine']);

    return _react2.default.createElement(_CheckboxField2.default, props);
}, {
    onChangeTransform: function onChangeTransform(e) {
        return e.target.checked;
    }
});

// eslint-disable-next-line no-unused-vars
exports.Checkbox = Checkbox;
var CheckboxGroup = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref4) {
    var validating = _ref4.validating,
        pristine = _ref4.pristine,
        props = _objectWithoutProperties(_ref4, ['validating', 'pristine']);

    return _react2.default.createElement(_CheckboxGroupField2.default, props);
});

// eslint-disable-next-line no-unused-vars
exports.CheckboxGroup = CheckboxGroup;
var Toggles = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref5) {
    var validating = _ref5.validating,
        pristine = _ref5.pristine,
        props = _objectWithoutProperties(_ref5, ['validating', 'pristine']);

    return _react2.default.createElement(_TogglesField2.default, props);
});

// eslint-disable-next-line no-unused-vars
exports.Toggles = Toggles;
var RadioGroup = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref6) {
    var validating = _ref6.validating,
        pristine = _ref6.pristine,
        props = _objectWithoutProperties(_ref6, ['validating', 'pristine']);

    return _react2.default.createElement(_RadioGroupField2.default, props);
}, {
    onChangeTransform: function onChangeTransform(e) {
        return e.target.value;
    }
});

// eslint-disable-next-line no-unused-vars
exports.RadioGroup = RadioGroup;
var Select = (0, _reduxInputs.ReduxInputsWrapper)(function (_ref7) {
    var validating = _ref7.validating,
        pristine = _ref7.pristine,
        props = _objectWithoutProperties(_ref7, ['validating', 'pristine']);

    return _react2.default.createElement(_LogicalSelectField2.default, props);
}, {
    onChangeTransform: function onChangeTransform(e) {
        return e;
    }
});

// Let users get anything from redux-inputs so they don't have to explicitly depend on it
exports.Select = Select;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/zsg-redux-inputs/index.js
// module id = 631
// module chunks = 0